import { EventEmitter, Injectable } from '@angular/core';
import { OWNER_ACTION_PERMISSION } from '@d-constants/permission.constant';
import { environment } from '@d-environments/environment';
import { BaseSearchRequest } from '@d-models';
import { IRoles, PermissionPortalModule } from '@d-models/other/user.model';
import { HttpService } from '@d-services/other/http.service';
import { getCurrentPermission } from '@d-store/app-config/app-config.selector';
import { AppState } from '@d-store/constant';
import { Store, select } from '@ngrx/store';
import _each from 'lodash-es/each';
import _findIndex from 'lodash-es/findIndex';
import { CoreHttpService } from './core-http.service';
import { CoreUserService } from './user.service';
import { ConstantPool } from '@angular/compiler';
environment.API_URL;
@Injectable()
export class RoleService {
  private _currentPermission: PermissionPortalModule[];
  constructor(
    private httpService: HttpService,
    private coreHttp: CoreHttpService,
    private store: Store<AppState>,
    private userService: CoreUserService,
  ) {
    this.store.pipe(select(getCurrentPermission)).subscribe((_) => {
      this.currentPermission = _;
    });
  }

  get currentPermission() {
    return this._currentPermission;
  }

  set currentPermission(val: PermissionPortalModule[]) {
    this._currentPermission = val;
  }

  getAll() {
    return this.coreHttp.get('Roles/GetAll', {
      useTenantCompanyId: false,
    });
  }
  getAllDeleted() {
    return this.coreHttp.get('Roles/GetAllDeleted');
  }

  buildCoreSearchBody(body: any) {
    const {
      pageIndex,
      pageSize,
      sortBy,
      searchGlobal,
      advancedFilter,
      statuses,
    } = body;
    const filter: any = advancedFilter || {};
    if (searchGlobal.filterBy && searchGlobal.searchBy) {
      filter[searchGlobal.filterBy] = searchGlobal.searchBy;
    }
    filter.status = advancedFilter?.['status'] ?? statuses?.[0];
    const sort =
      sortBy?.map((sort: any) => ({
        field:
          sort.fieldName.charAt(0)?.toLowerCase() + sort.fieldName.slice(1),
        asc: sort.ascending,
      })) || [];
    return {
      pageIndex: pageIndex - 1,
      pageSize,
      sort,
      filter: Object.entries(filter)
        .filter(([_, v]) => v !== null && v !== undefined)
        .map(([key, value]) => ({
          field: key,
          valueString: value,
        })),
    };
  }

  searchRoles(request: BaseSearchRequest, { headers = {} } = {}) {
    const body = this.buildCoreSearchBody(
      this.httpService.buildSearchRequest(request),
    );
    return this.coreHttp.post<IRoles[]>('Roles/GetAllByPaging', body, {
      headers,
      useTenantCompanyId: false,
    });
  }

  deleteRoles(ids: string[]) {
    return this.coreHttp.post('Roles/DeleteMulti', ids, {
      useTenantCompanyId: false,
    });
  }

  getDetail(id: string) {
    return this.coreHttp.get(`Roles/GetById?id=${id}`, {
      useTenantCompanyId: false,
    });
  }
  addRole(postData: any) {
    return this.coreHttp.post('Roles/Create', postData, {
      useTenantCompanyId: false,
    });
  }
  copyRole(postData: any) {
    return this.coreHttp.post(`Roles/Clone?id=${postData.id}`, postData);
  }
  updateRole(id: string, postData: any) {
    return this.coreHttp.put(`Roles/Update?id=${id}`, postData, {
      useTenantCompanyId: false,
    });
  }
  restoreRole(ids: string[]) {
    return this.coreHttp.post('Roles/RestoreMulti', ids);
  }
  getUserPermissions(option?: {
    appCode?: 'WMS_OP' | 'WMS_PO';
    useTenantCompanyId?: boolean;
    useUserInfoCompanyId?: boolean;
  }) {
    return this.coreHttp.get(
      option && option.appCode
        ? `Users/GetUserPermissions?appCode=${option.appCode}`
        : 'Users/GetUserPermissions',
      {
        useTenantCompanyId: option?.useTenantCompanyId,
        useUserInfoCompanyId: option?.useUserInfoCompanyId,
      },
    );
  }

  searchRoleDeleted(postData: any) {
    return this.coreHttp.post('Roles/GetAllDeleted', postData);
  }

  private currentUserRoles: any = null;
  reloadCurrentUserRoles: EventEmitter<any> = new EventEmitter();
  public getCurrentUserRoles() {
    return this.currentUserRoles;
  }
  public setCurrentUserRoles(value: any) {
    this.currentUserRoles = value;
    this.emitReloadCurrentUserRoles();
  }

  public emitReloadCurrentUserRoles() {
    // this.reloadCurrentUserRoles.next();
    this.reloadCurrentUserRoles.emit();
  }

  getActions(moduleCode: string) {
    var rs: any[] = [];
    var _self = this;
    var temp = [
      {
        modules: _self.currentUserRoles,
      },
    ];
    _each(temp, function (o: any) {
      var actions = _self.getActionByModule(o.modules, moduleCode);
      rs = rs.concat(actions);
    });
    var actions: any[] = [];
    _each(rs, function (o: any) {
      var idx = _findIndex(actions, function (x: any) {
        return o.actionName == x;
      });
      if (idx == -1) {
        actions.push(o.actionName);
      }
    });
    return actions;
  }

  getActionByModule(modules: any, moduleCode: string) {
    var rs: any[] = [];
    var _self = this;
    _each(modules, function (x: any) {
      if (x.moduleCode == moduleCode) {
        if (x.modules == null || x.modules.length <= 0) {
          rs = x.actions;
        } else {
          rs = rs.concat(_self.getActionByModule(x.modules, moduleCode));
        }
      }
    });
    return rs;
  }

  /**
   *
   * @param moduleCode
   * @param actionName ACTION_PERMISSION or OWNER_ACTION_PERMISSION
   * @param createdBy email of author
   * @returns
   */

  checkPermissionByAction(
    moduleCode: string | object | Array<string | object>,
    actionName: string | string[],
    createdBy?: string,
  ) {
    const filteredModule = this.currentPermission.filter((permission) =>
      typeof moduleCode === 'string'
        ? moduleCode === permission.moduleCode
        : this.flatModuleCode(moduleCode).some(
            (code) => code === permission.moduleCode,
          ),
    );
    if (!filteredModule.length) return false;
    const actionsList = filteredModule
      .flatMap((m) => m.actions)
      .filter((a) => actionName.includes(a.actionName));
    if (!actionsList.length) return false;

    const ownerActionList = actionsList.filter((a) =>
      Object.values(OWNER_ACTION_PERMISSION).includes(a.actionName),
    );

    if (!ownerActionList.length || !createdBy) return true;

    return (
      createdBy === this.userService.getCurrentUser().email ||
      createdBy === this.userService.getCurrentUser().userId
    );
  }

  getActionsByModuleCode(moduleCode: string | object | Array<string | object>) {
    if (typeof moduleCode === 'string') {
      const selectedModule = this.currentPermission.find(
        (i) => moduleCode === i.moduleCode,
      );
      return selectedModule ? selectedModule.actions : undefined;
    }

    if (Array.isArray(moduleCode)) {
      return moduleCode.map((m) => this.getActionsByModuleCode(m)).flat();
    }

    if (typeof moduleCode === 'object') {
      const rs = Object.keys(moduleCode).map((code) =>
        this.getActionsByModuleCode(moduleCode[code]),
      );
      return rs.every((r) => r === undefined) ? undefined : rs.flat();
    }
  }

  private flatModuleCode(moduleCode: string | object | Array<string | object>) {
    if (typeof moduleCode === 'string') {
      return moduleCode;
    }

    if (Array.isArray(moduleCode)) {
      return moduleCode.flatMap((m) => this.flatModuleCode(m));
    }

    if (typeof moduleCode === 'object') {
      return Object.keys(moduleCode).flatMap((code) =>
        this.flatModuleCode(moduleCode[code]),
      );
    }
  }
}
